import type { CardKind, Team } from '../shared/types';

export const partyAsset = (name: string) => `/art/c-v1/${name}.webp`;
export const pawnAsset = (team:Team,count=1) => count>1 ? `/art/c-v2/pawn-${team==='A'?'sun':'moon'}-${Math.min(4,count)}.webp` : partyAsset(team==='A'?'pawn-sun':'pawn-moon');
export function PawnArt({ team, count=1, className = '' }: { team: Team; count?:number; className?: string }) {
  return <img className={`pawn-art ${className}`} src={pawnAsset(team,count)} alt="" draggable={false} />;
}
export function CardArt({ card, className = '' }: { card: CardKind; className?: string }) {
  return <img className={`card-art ${className}`} src={partyAsset(`card-${card}`)} alt="" loading="lazy" draggable={false} />;
}
